import csrfToken from "./csrf_token"
//dependency
const $ = window.jQuery

$(document).ajaxSend((event, xhr, settings) => {
  if(settings.type != "GET") {
    xhr.setRequestHeader("X-CSRF-Token", csrfToken)
  }
})

export default $.ajax
